import { motion } from "framer-motion";
import { Smartphone, Apple, Monitor, Tv } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";

const Card = ({ icon: Icon, title, text, img, className = "", delay, testid }) => (
  <Reveal delay={delay} className={className}>
    <motion.div whileHover={{ y: -6 }} transition={{ type: "spring", stiffness: 260, damping: 20 }}
      className="group relative h-full overflow-hidden rounded-[28px] border border-white/10 bg-[#13114f] p-7 md:p-8 flex flex-col justify-between min-h-[220px] hover:border-[#5b5fd6] transition-colors" data-testid={testid}>
      <img src={img} alt={title} loading="lazy" decoding="async" width="640" height="427"
        className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.2s] group-hover:scale-105" />
      <span className="absolute inset-0 bg-gradient-to-t from-[#08072a] via-[#0d0b3d]/55 to-transparent" />
      <span className="relative grid h-12 w-12 place-items-center rounded-2xl bg-white/10 backdrop-blur text-white group-hover:bg-[#5b5fd6] transition-colors">
        <Icon size={22} />
      </span>
      <div className="relative">
        <h3 className="font-display text-xl md:text-2xl font-semibold mt-8">{title}</h3>
        <p className="mt-2 text-sm text-white/85">{text}</p>
      </div>
    </motion.div>
  </Reveal>
);

export default function Devices() {
  return (
    <section id="cihazlar" className="relative bg-[#08072a] py-24 md:py-36" data-testid="devices-section">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <SectionHead kicker="01 · Her Ekranda" title={<>Tek hesap.<br />Dört platform.</>} testid="devices-title"
          sub="Android, iOS, bilgisayar ve TV'den giriş yap. Salonda başla, telefonda devam et." />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 lg:grid-rows-2 gap-4 md:gap-5">
          <Reveal className="md:col-span-2 lg:row-span-2">
            <div className="relative h-full min-h-[340px] lg:min-h-[460px] overflow-hidden rounded-[28px] border border-white/10 group" data-testid="device-card-tv">
              <img src="/img/googletv.jpg" alt="Google TV arayüzü açık TV ekranı" className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.6s] group-hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#08072a] via-[#08072a]/40 to-transparent" />
              <div className="absolute bottom-0 p-7 md:p-10">
                <span className="grid h-12 w-12 place-items-center rounded-2xl bg-[#5b5fd6] text-white"><Tv size={22} /></span>
                <h3 className="font-display text-2xl md:text-4xl font-extrabold uppercase mt-6">Smart TV & Android Box</h3>
                <p className="mt-2 text-[#c9c6f0] max-w-sm">Büyük ekranda, koltuğunun keyfini çıkararak izle.</p>
              </div>
            </div>
          </Reveal>
          <Card icon={Smartphone} title="Android" text="Telefon ve tablette her an yanında." img="/img/dev-android.jpg" delay={0.1} testid="device-card-android" />
          <Card icon={Apple} title="iOS" text="iPhone ve iPad ile akıcı izleme." img="/img/dev-ios.jpg" delay={0.18} testid="device-card-ios" />
          <Card icon={Monitor} title="Bilgisayar" text="Windows'ta masaüstünden geniş ekran keyfi." img="/img/dev-windows.jpg" delay={0.26} className="md:col-span-2" testid="device-card-pc" />
        </div>
      </div>
    </section>
  );
}
